import script from "./ContactsGroupInfoView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactsGroupInfoView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__